import { View, Text, Pressable, Modal, ScrollView, StyleSheet } from 'react-native';
import { useAppStore } from '../store/appStore';

export default function FootnoteModal() {
  const showNote = useAppStore((s) => s.showNote);
  const verseNoteTitle = useAppStore((s) => s.verseNoteTitle);
  const verseFootnotes = useAppStore((s) => s.verseFootnotes);
  const setShowNote = useAppStore((s) => s.setShowNote);

  const htmlContent = verseFootnotes.length > 0
    ? verseFootnotes.join('<hr style="border:none;border-top:1px solid #eee;margin:8px 0;">')
    : '<p>No footnotes available for this verse.</p>';

  return (
    <Modal
      visible={showNote}
      transparent
      animationType="fade"
      onRequestClose={() => setShowNote(false)}
    >
      <Pressable style={styles.overlay} onPress={() => setShowNote(false)}>
        <Pressable style={styles.dialog} onPress={() => {}}>
          <View style={styles.header}>
            <Text style={styles.title}>{verseNoteTitle}</Text>
            <Pressable onPress={() => setShowNote(false)} style={styles.closeBtn}>
              <Text style={styles.closeText}>×</Text>
            </Pressable>
          </View>
          <ScrollView style={styles.body} contentContainerStyle={styles.bodyContent}>
            <div
              style={{ fontSize: 14, lineHeight: '28px', color: '#333', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' }}
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          </ScrollView>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialog: {
    backgroundColor: '#fff',
    borderRadius: 4,
    maxWidth: 500,
    width: '90%' as any,
    maxHeight: '80%' as any,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#d3d3d3',
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#333',
    flex: 1,
  },
  closeBtn: {
    padding: 8,
  },
  closeText: {
    fontSize: 24,
    color: '#000',
    opacity: 0.5,
  },
  body: {
    paddingHorizontal: 24,
    paddingVertical: 10,
  },
  bodyContent: {
    paddingBottom: 20,
  },
});
